import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { Grid, Stack, Typography } from "@mui/material";
import { FC, useEffect, useMemo, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { LearnerFormTitle } from "@/features/learner/components/learner-form/LearnerFormTitle";
import { calculateResidencePeriods } from "@/features/learner/utils/calculates";
import { black } from "@/theme/colors";

export const LearnerResidenceInfoForm: FC = () => {
  const { control, watch, trigger, setValue } = useFormContext<TLearnerForm>();
  const clause1StartDate = watch("clause1StartDate");
  const blankPeriodMonths = watch("blankPeriodMonths");

  // Skip cross-trigger on initial render
  const isInitialRender = useRef(true);
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    trigger("blankPeriodMonths");
    trigger("clause1StartDate");
  }, [clause1StartDate, blankPeriodMonths, trigger]);

  const periods = useMemo(
    () => calculateResidencePeriods(clause1StartDate, blankPeriodMonths),
    [clause1StartDate, blankPeriodMonths],
  );

  return (
    <InnerBox title={<LearnerFormTitle text="在留資格情報" />} showDivider={false}>
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="clause1StartDate">
            <InputDatePicker
              placeholder="2022/01/01"
              onChange={(value) => {
                if (!value) setValue("blankPeriodMonths", null, { shouldValidate: true, shouldDirty: true });
              }}
            />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="blankPeriodMonths">
            <Input placeholder="入力してください" endAdornment="か月" disabled={!clause1StartDate} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <Stack spacing={1}>
            <Typography variant="cap12Light" color={black[70]}>
              1号経過期間（自動計算）
            </Typography>
            <Typography variant="body14">
              {periods.elapsed}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack spacing={1}>
            <Typography variant="cap12Light" color={black[70]}>
              1号残期間（自動計算）
            </Typography>
            <Typography variant="body14">
              {periods.remaining}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
